// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yr7dPrXIO5nvyq8k1sV7{display:flex;flex-direction:column;align-items:flex-start;gap:12px}.wyeJV3jVkx7eoVs3DcST{white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/pages/chatbot/ui/AgentKnowledgeBase/ui/PointKnowledgeBaseUsage/KnowledgeBaseAlert/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,sBAAA,CACA,QAAA,CAEA,sBACE,kBAAA","sourcesContent":[".alert {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n\n  &Button {\n    white-space: nowrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `yr7dPrXIO5nvyq8k1sV7`,
	"alertButton": `wyeJV3jVkx7eoVs3DcST`
};
export default ___CSS_LOADER_EXPORT___;
